import Footer from "../../../components/footer";
import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";
import Lottie from "react-lottie";
import dotLoading from "../../../assets/Dot loading.json";

import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import { DestinationAccountControllerType } from "../useDestinationAccount";
import { useEffect, useState } from "react";
import { LoadingContainer, LoadingTextContainer, TileContainer } from "./styles";
import { BodyLargeRegular, HeadlineMedium, Highlight } from "../../../components/font";
import { AccountTile, Button } from "@manifesthhqinc/ui-library";
import loadingAndFound from "../../../assets/Dot loading and found.json";
import HeadingContainer from "../../../layout/heading-container";

const IRAFoundScreen = (props: DestinationAccountControllerType) => {
  const {
    setIsLoading,
    providerIRAName,
    currentDestinationDetails,
    onClickContinue,
    onClickSkip,
    isIRAFoundAnimationLoaded,
    setIsIRAFoundAnimationLoaded,
  } = props;

  const [loadingStep, setLoadingStep] = useState<number>(0);

  useEffect(() => {
    setIsLoading(!isIRAFoundAnimationLoaded);
  }, [isIRAFoundAnimationLoaded]);

  const onFinishAnimation = () => {
    setLoadingStep(1);
  };

  const onFinishLoading = () => {
    setIsIRAFoundAnimationLoaded(true);
    setIsLoading(false);
  };

  if (!isIRAFoundAnimationLoaded) {
    return (
      <TransitionWrapper>
        <ScrollableContainer name="confirm-destination-account">
          <LoadingContainer>
            {loadingStep === 0 ? (
              <Lottie
                options={{
                  loop: false,
                  autoplay: true,
                  animationData: dotLoading,
                }}
                style={{ width: 200, height: 200 }}
                eventListeners={[
                  {
                    eventName: "complete",
                    callback: onFinishAnimation,
                  },
                ]}
              />
            ) : (
              <Lottie
                options={{
                  loop: false,
                  autoplay: true,
                  animationData: loadingAndFound,
                }}
                style={{ width: 200, height: 200 }}
                eventListeners={[
                  {
                    eventName: "complete",
                    callback: onFinishLoading,
                  },
                ]}
              />
            )}
            {loadingStep === 0 ? (
              <LoadingTextContainer>
                <HeadlineMedium $textAlign="center">Just a moment...</HeadlineMedium>
                <BodyLargeRegular $textAlign="center">
                  Seeing if you have any existing accounts to transfer into.
                </BodyLargeRegular>
              </LoadingTextContainer>
            ) : (
              <LoadingTextContainer>
                <HeadlineMedium $textAlign="center">
                  We found an existing <Highlight>{providerIRAName}</Highlight> IRA{" "}
                </HeadlineMedium>
              </LoadingTextContainer>
            )}
          </LoadingContainer>
        </ScrollableContainer>
      </TransitionWrapper>
    );
  }

  return (
    <TransitionWrapper>
      <ScrollableContainer name="ira-found-screen">
        <Container>
          <HeadingContainer paneVariant="form" withProgressBar>
            <HeadlineMedium $textAlign="center">Transfer into your existing account?</HeadlineMedium>
            <BodyLargeRegular $textAlign="center">
              Since your 401(k) is already with {providerIRAName}, a rollover to a {providerIRAName} IRA is usually the
              easiest path.
            </BodyLargeRegular>
          </HeadingContainer>
          <TileContainer $flexDirection="column" $width="100%">
            <AccountTile
              title={currentDestinationDetails.providerName}
              subtitle={
                <>
                  Individual Retirement Account
                  <br />
                  {currentDestinationDetails.traditionalIraAccountNumber}
                </>
              }
              type="destination-account"
            />
          </TileContainer>
        </Container>
      </ScrollableContainer>
      <Footer>
        <Button onClick={onClickContinue} size="large" name="continue">
          Continue
        </Button>
        <Button className="secondary-cta" variant="text" size="large" onClick={onClickSkip} name="skip">
          No, skip
        </Button>
      </Footer>
    </TransitionWrapper>
  );
};

export default IRAFoundScreen;
